/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createDemandStatusRequestSchema = z.object({
  category: z.enum(['OPEN', 'EVALUATING', 'DECIDED', 'WITHDRAWN']),
  color: z.string(),
  isOrganizationDefault: z.optional(z.boolean()),
  name: z.string(),
  sortOrder: z.int(),
});
